export const popupFormWidth = '600px';
